import React, { useEffect, useMemo, useState } from "react";
import CoinPackIcon from "../../assets/icons/CoinPackIcon";

type DynamicCoinPackIconProps = {
  coinUrl?: string;
  className?: string;
};

const DynamicCoinPackIcon = ({
  coinUrl,
  className,
}: DynamicCoinPackIconProps) => {
  const [hasImageError, setHasImageError] = useState(false);
  const combinedClassName = useMemo(() => {
    return ["gi-coin-icon", className].filter(Boolean).join(" ");
  }, [className]);

  const normalizedCoinUrl = useMemo(() => {
    if (typeof coinUrl !== "string") return "";
    return coinUrl.trim();
  }, [coinUrl]);

  useEffect(() => {
    setHasImageError(false);
  }, [normalizedCoinUrl]);

  if (!normalizedCoinUrl || hasImageError) {
    return <CoinPackIcon className={combinedClassName} aria-hidden="true" />;
  }

  return (
    <span className={combinedClassName} aria-hidden="true">
      <img
        src={normalizedCoinUrl}
        alt=""
        loading="lazy"
        onError={() => setHasImageError(true)}
      />
    </span>
  );
};

export default DynamicCoinPackIcon;
